import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useSelector } from 'react-redux';
import CalendarIcon from '../../assets/img/calendar.svg';
import CloseButton from '../../assets/img/close-icon.svg';
import { toServerDate } from '../Utils/Helper';
import { formatDates } from '../Utils/Utils';
import './Componenents.scss';
const RcylDatePicker = ({
  value,
  format = 'DD-MMM-YYYY',
  onApply,
  placeholder = 'Select Date',
  isInvalid,
  errorMessage,
  disabled,
  minDate,
  maxDate,
  inputClass = '',
  inputProps = {},
  startDate,
  endDate,
  controlId,
  singleDatePicker = false,
  className,
  range = true,
  showClear = false,
  portal = true,
  inputgroupStyle = {},
  inputfieldStyle = true,
  isbasedonFinYear = false,
  isbasedonFulYear = false,
  currentDate = new DateObject(),
  onClear,
  ...restProps
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(value || startDate);
  const [selectedMultipleDate, setSelectedMultipleDate] = useState([null, null]);
  const { isUsingFulfilment, selectedFulfilmentYear, selectedFinancialYear } = useSelector(
    (state) => state?.account
  );
  const datePickerRef = useRef(null);

  useEffect(() => {
    if (!!(value || startDate)) setSelectedDate(value || startDate);
    setSelectedMultipleDate([
      startDate ? new DateObject(startDate) : null,
      endDate ? new DateObject(endDate) : null,
    ]);
  }, [value, startDate, endDate]);

  const handleOnApply = (dates) => {
    if (onApply) {
      if (Array.isArray(dates)) {
        const [start, end] = formatDates(dates);
        let startDate = start ? toServerDate(start?.toDate()) : '';
        let endDate = end ? toServerDate(end?.toDate()) : '';
        onApply({ startDate, endDate });
      } else {
        let date = dates ? toServerDate(dates?.toDate()) : '';
        onApply({ startDate: date });
      }
    }
    setIsOpen(false);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
    handleOnApply(date);
  };

  const handleRangeChange = (dates) => {
    if (Array.isArray(dates) && dates?.length === 2) {
      dates = [dates[0], dates[1]];
    }

    setSelectedMultipleDate(dates);
    if (dates?.length === 2 && dates[0] && dates[1]) {
      handleOnApply(dates);
      datePickerRef.current?.closeCalendar();
    }
  };

  const handleClear = () => {
    setSelectedMultipleDate([null, null]);
    setSelectedDate('');
    if (onApply) {
      handleOnApply([null, null]);
    }
    onClear && onClear();
    setIsOpen(false);
  };
  let finalMinDate = minDate
    ? new DateObject(minDate)
    : isbasedonFinYear && isbasedonFulYear
      ? new DateObject(
          isUsingFulfilment ? selectedFulfilmentYear?.fromDate : selectedFinancialYear?.fromDate
        )
      : isbasedonFinYear
        ? new DateObject(selectedFinancialYear?.fromDate)
        : isbasedonFulYear
          ? new DateObject(selectedFulfilmentYear?.fromDate)
          : null;
  let finalMaxDate = maxDate
    ? new DateObject(maxDate)
    : isbasedonFinYear && isbasedonFulYear
      ? new DateObject(
          isUsingFulfilment ? selectedFulfilmentYear?.toDate : selectedFinancialYear?.toDate
        )
      : isbasedonFinYear
        ? new DateObject(selectedFinancialYear?.toDate)
        : isbasedonFulYear
          ? new DateObject(selectedFulfilmentYear?.toDate)
          : null;

  return singleDatePicker || !range ? (
    <div className="MultiDatePicker ">
      <DatePicker
        portal={portal}
        currentDate={currentDate ? new DateObject(currentDate) : null}
        value={selectedDate ? new DateObject(selectedDate) : null}
        onChange={handleDateChange}
        format={format}
        minDate={finalMinDate}
        maxDate={finalMaxDate}
        calendarPosition="bottom-left"
        containerClassName="w-100"
        onOpenPickNewDate={false}
        className={`MultiDatePicker ${className || inputClass || ''}`}
        render={(value, openCalendar) => (
          <InputGroup onClick={disabled ? () => {} : openCalendar}>
            <Form.Control
              isInvalid={isInvalid}
              placeholder={placeholder}
              disabled={disabled}
              autoComplete="off"
              className={`${inputfieldStyle ? 'inputfield_rcyklpicker_style' : ''}  ${inputClass || className}`}
              value={value}
              {...inputProps}
            />

            <InputGroup.Text
              className={classNames(
                { 'bg-disabled-date-picker icons_padding_rcyklpicker': disabled },
                { 'bg-white icons_padding_rcyklpicker': !disabled }
              )}
              style={inputgroupStyle ? inputgroupStyle : {}}>
              {showClear && selectedDate ? (
                <img
                  src={CloseButton}
                  width="20px"
                  height="10px"
                  alt="close"
                  style={{ cursor: disabled ? '' : 'pointer' }}
                  onClick={disabled ? () => {} : () => handleClear()}
                />
              ) : (
                <img src={CalendarIcon} width="20px" height="15px" alt="search" />
              )}
            </InputGroup.Text>
            {errorMessage && (
              <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
            )}
          </InputGroup>
        )}
      />
    </div>
  ) : (
    <div className="MultiDatePicker">
      <DatePicker
        ref={datePickerRef}
        portal={portal}
        value={selectedMultipleDate}
        onChange={handleRangeChange}
        range={true}
        numberOfMonths={2}
        format={format}
        isInvalid={isInvalid}
        placeholder={placeholder}
        disabled={disabled}
        minDate={finalMinDate}
        maxDate={finalMaxDate}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className={`MultiDatePicker ${className || inputClass || ''}`}
        render={(value, openCalendar) => (
          <InputGroup onClick={() => (disabled ? {} : openCalendar())}>
            <Form.Control
              isInvalid={isInvalid}
              placeholder={placeholder}
              disabled={disabled}
              autoComplete="off"
              className={`${className || ''} MultiDatePicker ${inputfieldStyle ? 'inputfield_rcyklpicker_style' : ''}   ${inputClass || ''}`}
              value={value}
              {...inputProps}
              readOnly
              onClick={() => setIsOpen(true)}
            />
            <InputGroup.Text
              className={classNames(
                { 'bg-disabled-date-picker icons_padding_rcyklpicker': disabled },
                { 'bg-white icons_padding_rcyklpicker': !disabled }
              )}
              style={inputgroupStyle ? inputgroupStyle : {}}>
              {showClear && (selectedMultipleDate[0] || selectedMultipleDate[1]) ? (
                <img
                  src={CloseButton}
                  alt="close"
                  width="20px"
                  height="10px"
                  style={{ cursor: disabled ? '' : 'pointer' }}
                  onClick={() => (disabled ? {} : handleClear())}
                />
              ) : (
                <img src={CalendarIcon} width="20px" height="15px" alt="search" />
              )}
            </InputGroup.Text>
            {errorMessage && (
              <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
            )}
          </InputGroup>
        )}
      />
    </div>
  );
};

RcylDatePicker.propTypes = {
  value: PropTypes.any,
  onApply: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isInvalid: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  inputClass: PropTypes.string,
  inputProps: PropTypes.object,
};

export default RcylDatePicker;
